(function() {
	$(".spinner").spinner({
		'delay': 200,
		'max': 99
	});
})();


// WEBPACK FOOTER //
// G:/RABOTA/satpharma/dev/source/modules/spinner/spinner.js